import { useState, useEffect } from 'react';
import butterflyApi from '../ButterflyApi.js';

const HoldingTasks = () => {
  const [tasks, setTasks] = useState()

  useEffect(() => {
    const load = async () => {
      const data = await butterflyApi.getHoldingTasks()
      setTasks(data)
    }
    load()
  }, [])

  return <div className="px-4 mt-12 max-w-5xl">
    <div className="mb-4">
      <a href="/manage" className="text-blue-600 underline">Manage</a>
    </div>
    <div className="font-bold text-lg mb-4">Holding Tasks</div>
    {tasks && tasks.length === 0 && <div className="text-gray-400 text-sm">데이터 없음</div>}
    {tasks && tasks.length > 0 && (
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="bg-gray-100 text-gray-600 text-left">
            <th className="px-3 py-2 border border-gray-200">taskNo</th>
            <th className="px-3 py-2 border border-gray-200">heroNo</th>
            <th className="px-3 py-2 border border-gray-200">scriptNo</th>
            <th className="px-3 py-2 border border-gray-200">pageNo</th>
            <th className="px-3 py-2 border border-gray-200">taskType</th>
            <th className="px-3 py-2 border border-gray-200">done</th>
            <th className="px-3 py-2 border border-gray-200">holding</th>
            <th className="px-3 py-2 border border-gray-200">comment</th>
            <th className="px-3 py-2 border border-gray-200">등록일시</th>
            <th className="px-3 py-2 border border-gray-200">완료일시</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map(task => (
            <tr key={task.taskNo} className="hover:bg-gray-50">
              <td className="px-3 py-2 border border-gray-200 text-gray-400">{task.taskNo}</td>
              <td className="px-3 py-2 border border-gray-200">
                <a href={`/manage/hero?heroNo=${task.heroNo}`} className="text-blue-600 underline">{task.heroNo}</a>
              </td>
              <td className="px-3 py-2 border border-gray-200">
                <a href={`/manage/story?heroNo=${task.heroNo}&scriptNo=${task.scriptNo}`} className="text-blue-600 underline">{task.scriptNo}</a>
              </td>
              <td className="px-3 py-2 border border-gray-200 text-gray-500">{task.pageNo ?? '-'}</td>
              <td className="px-3 py-2 border border-gray-200">{task.taskType}</td>
              <td className="px-3 py-2 border border-gray-200">{task.done ? 'Y' : 'N'}</td>
              <td className="px-3 py-2 border border-gray-200">{task.holding ? 'Y' : task.holding === false ? 'N' : '-'}</td>
              <td className="px-3 py-2 border border-gray-200 text-gray-500">{task.comment ?? '-'}</td>
              <td className="px-3 py-2 border border-gray-200 text-gray-500">{task.registerDatetime}</td>
              <td className="px-3 py-2 border border-gray-200 text-gray-500">{task.doneDatetime ?? '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
}

export default HoldingTasks
